import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';
import {
  LAST_REFERENCE_PERIOD,
  REFERENCE_PERIODS,
} from 'lumen/utils/constants/rate-strategy-constants';
import getAPIErrorMessage from 'lumen/utils/get-api-error-message';

export default class HotelStrategyRoute extends Route {
  queryParams = {
    competitors: {
      refreshModel: false,
    },
  };

  @service access;
  @service alerting;
  @service errorTracking;
  @service('hotel-and-market') hotelAndMarketService;
  @service intl;
  @service rsSelections;
  @service store;
  @service transition;

  modelTask = task({ restartable: true }, async () => {
    try {
      const apiParams = {
        namespace: APIGATEWAY,
        typeKey: 'ratestrategy',
        hotel_id: this.hotelAndMarketService.hotel?.id,
        compset_ids: '1,2', // Request both primary and secondary compset
        weeks: Object.values(REFERENCE_PERIODS), // Query all periods for now
      };

      const ratestrategies = await this.store.query('rate-strategy', apiParams);
      const latestRatestrategy = ratestrategies.find(
        (rs) => rs.extractDate === LAST_REFERENCE_PERIOD,
      ); // Fetch latest rate-strategy
      this.rsSelections.initBaseRatesProperties(latestRatestrategy.rsbaserates);
      return latestRatestrategy.rstypes;
    } catch (error) {
      if (error) {
        this.errorTracking.captureException(error);
      }

      this.alerting.showErrorAlert({
        text: getAPIErrorMessage(error, this.intl),
      });
    }

    return null;
  });

  beforeModel(transition) {
    if (!this.access.hasRateStrategyAccess) {
      this.transition.redirectToEnabledTab(transition);
    } else if (
      transition.targetName === 'hotel.strategy.los' &&
      !this.access.hasFeature('rate_strategy.blocks.los')
    ) {
      this.transition.redirectToTab(transition, 'hotel.strategy');
    } else {
      this.transition.validateRateStrategyQueryParams(
        transition,
        this.paramsFor(this.routeName), // Use paramsFor to obtain the deserialised query params
      );
    }
  }

  didTransition() {
    super.didTransition(...arguments);

    // Clear RS models from store when exiting RS route (needed when switching hotels)
    this.store.unloadAll('ratestrategies');
    this.store.unloadAll('rsbaserate');
    this.store.unloadAll('rstypes');
    this.store.unloadAll('rssubtypes');
    this.store.unloadAll('rsstrategies');
    this.store.unloadAll('rscancellationpolicies');
    this.store.unloadAll('rspatterns');
  }

  model(params) {
    const model = {
      typeData: this.modelTask.perform(params),
    };

    return model;
  }
}
